var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.6426 2.68303C12.0652 -0.894343 6.2604 -0.894343 2.68303 2.68303C-0.894343 6.2604 -0.894343 12.0652 2.68303 15.6426C6.2604 19.2199 12.0652 19.2199 15.6426 15.6426C19.2274 12.0652 19.2274 6.2604 15.6426 2.68303Z",
    fill: "url(#paint0_radial_1086_21826)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16281 15.7028C12.7746 15.7028 15.7026 12.7749 15.7026 9.16306C15.7026 5.55124 12.7746 2.62329 9.16281 2.62329C5.551 2.62329 2.62305 5.55124 2.62305 9.16306C2.62305 12.7749 5.551 15.7028 9.16281 15.7028Z",
    fill: "url(#paint1_radial_1086_21826)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16281 15.7028C12.7746 15.7028 15.7026 12.7749 15.7026 9.16306C15.7026 5.55124 12.7746 2.62329 9.16281 2.62329C5.551 2.62329 2.62305 5.55124 2.62305 9.16306C2.62305 12.7749 5.551 15.7028 9.16281 15.7028Z",
    fill: "url(#paint2_radial_1086_21826)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2652 17.7204C12.97 17.7204 15.1626 15.5278 15.1626 12.8231C15.1626 10.1184 12.97 7.92578 10.2652 7.92578C7.56053 7.92578 5.36792 10.1184 5.36792 12.8231C5.36792 15.5278 7.56053 17.7204 10.2652 17.7204Z",
    fill: "url(#paint3_radial_1086_21826)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7451 16.7748C19.7397 16.7748 22.1674 14.3471 22.1674 11.3525C22.1674 8.35782 19.7397 5.93018 16.7451 5.93018C13.7504 5.93018 11.3228 8.35782 11.3228 11.3525C11.3228 14.3471 13.7504 16.7748 16.7451 16.7748Z",
    fill: "url(#paint4_radial_1086_21826)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.435 21.312C16.9409 21.312 18.9724 19.2805 18.9724 16.7746C18.9724 14.2687 16.9409 12.2373 14.435 12.2373C11.9291 12.2373 9.89771 14.2687 9.89771 16.7746C9.89771 19.2805 11.9291 21.312 14.435 21.312Z",
    fill: "url(#paint5_radial_1086_21826)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6604 22.7451H20.9149V16.1528H6.53037L5.6604 22.7451Z",
    fill: "url(#paint6_linear_1086_21826)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9149 22.7444C24.2741 22.7444 26.9972 20.0213 26.9972 16.6621C26.9972 13.303 24.2741 10.5798 20.9149 10.5798C17.5558 10.5798 14.8326 13.303 14.8326 16.6621C14.8326 20.0213 17.5558 22.7444 20.9149 22.7444Z",
    fill: "url(#paint7_radial_1086_21826)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6098 22.5046C19.3849 23.442 16.01 21.5821 15.0725 18.3572C14.1351 15.1323 15.995 11.7575 19.2199 10.82C22.4448 9.88252 25.8197 11.7425 26.7571 14.9673C27.6946 18.1922 25.8347 21.5671 22.6098 22.5046Z",
    fill: "url(#paint8_radial_1086_21826)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1502 8.00022C10.8652 7.94772 10.5652 7.91772 10.2652 7.91772C7.55784 7.91772 5.36792 10.1151 5.36792 12.815C5.36792 13.88 5.71291 14.87 6.29039 15.6799L8.14282 14.3375C7.05536 11.8626 7.62534 8.6452 11.1502 8.00022Z",
    fill: "url(#paint9_radial_1086_21826)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66039 22.7444C8.3651 22.7444 10.5577 20.5517 10.5577 17.847C10.5577 15.1423 8.3651 12.9497 5.66039 12.9497C2.95567 12.9497 0.763062 15.1423 0.763062 17.847C0.763062 20.5517 2.95567 22.7444 5.66039 22.7444Z",
    fill: "url(#paint10_radial_1086_21826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.16429 9.1642) scale(9.16604 9.16604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#FCCE38",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCE38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.42375 6.53295) scale(8.95568 8.95568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30417 6.04552) rotate(60.3595) scale(2.85704 5.37242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0444 14.5255) scale(11.3519 11.3519)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3454,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5956,
    stopColor: "#F3F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#E3EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4618 13.0581) scale(9.11146 9.11145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3454,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5956,
    stopColor: "#F3F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#E3EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7334 17.1322) scale(6.11194 6.11193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3454,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5956,
    stopColor: "#F3F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#E3EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1086_21826",
    x1: 13.2865,
    y1: 14.0364,
    x2: 13.2865,
    y2: 23.0057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3454,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5956,
    stopColor: "#F3F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#E3EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0028 11.4282) scale(12.0329 12.0329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    stopColor: "#F3F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8139,
    stopColor: "#E3EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2262 12.5278) rotate(73.8122) scale(11.2194 11.2183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3454,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5956,
    stopColor: "#F3F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#E3EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.24783 7.94773) rotate(119.175) scale(12.154 12.154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDCDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    stopColor: "#CFDCDE",
    stopOpacity: 0.8869
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1086_21826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.8986 13.5739) scale(9.45072)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3454,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5956,
    stopColor: "#F3F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#E3EBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDashboard);
export default __webpack_public_path__ + "static/media/cloud-dashboard.d9b64acb8fc7acde95c4138073bcbc2e.svg";
export { ForwardRef as ReactComponent };